import { render, staticRenderFns } from "./DashboardTotalClient.vue?vue&type=template&id=47e58048&"
import script from "./DashboardTotalClient.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports